import { useState } from "react";
import { SignRequest } from "@/services/backend/vbs/work-orders/api/work-order-api";
import { useDebouncedMutation } from "@/shared/lib/debounce/debounce";
import { SignatureDialog } from "@/services/backend/signature/components/signature-dialog";
import t from "@/lang/lang";
import { useHtzWorkOrderSignMutation } from "@/services/backend/htz/work-order/api/work-order-api";
import { hasFieldError } from "@/shared/lib/errors/validation-error";
import { useErrDocumentNotReady } from "@/shared/bsm/core/document/components/ui/err-document-not-ready";

export function SignatureButton(props: { workOrderId: string }) {
  const { workOrderId } = props;
  const [request, setRequest] = useState<SignRequest>({
    id: workOrderId,
    signature: "",
    dataFormat: "image/svg+xml:base64",
    nameOfSigner: "",
  });
  const mutation = useHtzWorkOrderSignMutation();

  // it was easier to use debounce to update the persistence state context
  useDebouncedMutation(
    request,
    setRequest,
    mutation,
    {
      id: workOrderId,
      signature: "",
      dataFormat: "image/svg+xml:base64",
      nameOfSigner: "",
    },
    { delay: 0 },
  );

  const { notReadyError, resetNotReadyErrorField } = useErrDocumentNotReady();
  const hasSigErr = hasFieldError(notReadyError, "signatureId");

  return (
    <div className={hasSigErr ? "border-destructive rounded-md border" : ""}>
      <SignatureDialog
        title={t("Arbeitsschein bestätigen")}
        name=""
        onConfirm={(data) => {
          setRequest({
            ...request,
            signature: data.signature,
            nameOfSigner: data.name,
          });
          resetNotReadyErrorField("signatureId");
        }}
      />
    </div>
  );
}
